import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Zap, MoonStar } from "lucide-react";
import { PRODUCT } from "@/lib/data";
import { track } from "@/lib/analytics";

export function StickyBuyBar({ onBuy }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 650);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-buy-bar"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-1/2 z-40 w-[calc(100%-2rem)] max-w-2xl -translate-x-1/2"
        >
          <div className="glass flex items-center gap-3 rounded-full border border-white/15 px-4 py-3 shadow-[0_20px_60px_rgba(0,0,0,0.6)] sm:gap-4 sm:px-5">
            <div className="hidden sm:block">
              <p className="font-display text-sm font-bold text-white">7-Night Sleep Reset</p>
              <p className="flex items-center gap-1.5 text-xs text-slate-400">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse-soft" /> Launch price — 70% off
              </p>
            </div>
            <span className="ml-auto hidden items-center gap-1.5 text-xs text-slate-400 sm:flex">
              <Zap className="h-3.5 w-3.5 text-cyan-400" /> Instant download
            </span>
            <div className="text-right">
              <span className="text-xs text-slate-500 line-through">${PRODUCT.compareAt.toFixed(2)}</span>
              <p className="font-display text-base font-extrabold text-white" data-testid="sticky-bar-price">${PRODUCT.price.toFixed(2)}</p>
            </div>
            <button
              data-testid="sticky-bar-buy-button"
              onClick={() => { track("InitiateCheckout", { value: PRODUCT.price, currency: "USD" }); onBuy(); }}
              className="flex items-center gap-2 rounded-full bg-cyan-400 px-5 py-2.5 text-sm font-bold text-[#07090e] transition-transform hover:scale-105 active:scale-95"
            >
              <MoonStar className="h-4 w-4" /> Get It
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
